import type { CallIntroFlowQuestions } from "@expert/contentful/src/api/getCallIntroFlowQuestions";
import type { JSX } from "react";

import { Checkbox, Select, Stack } from "@mantine/core";

export interface CallIntroQuestionsViewProps {
    questions: CallIntroFlowQuestions;
    isSingleSelection: boolean;
    currentSubscriptions: string[] | undefined;
    onSubscriptionsChange: (subscriptions: string[] | undefined) => void;
}

export function CallIntroQuestionsView({
    questions,
    isSingleSelection,
    currentSubscriptions,
    onSubscriptionsChange,
}: CallIntroQuestionsViewProps): JSX.Element {
    if (isSingleSelection) {
        const options = [
            { label: "None", value: "" },
            ...(questions.options.map((option) => ({
                label: option,
                value: option,
            })) || []),
        ];

        return (
            <Select
                data-testid="call-intro-questions"
                mt="1rem"
                label="Current subscription"
                data={options}
                value={currentSubscriptions?.length ? currentSubscriptions[0] : ""}
                onChange={(subscription) => {
                    if (subscription) {
                        onSubscriptionsChange([subscription]);
                    } else {
                        onSubscriptionsChange(undefined);
                    }
                }}
            />
        );
    }

    return (
        <Checkbox.Group
            data-testid="call-intro-questions"
            value={currentSubscriptions}
            onChange={onSubscriptionsChange}
            label={questions.question}
        >
            <Stack mt="xs">
                {questions.options.map((option) => (
                    <Checkbox key={option} value={option} label={option} />
                ))}
            </Stack>
        </Checkbox.Group>
    );
}
